import React from "react";

const Footer = () => {
  var currentTime = new Date();
  var year = currentTime.getFullYear();

  return (
    <div className="footer pt-4 pb-4">
      <div className="container">
        <div className="texts text-center">
          <div className="mt-4 mb-4">
            <a
              href="https://github.com/mdriyadtalukder"
              className="btn text-white ico "
              target="_blank"
            >
              {" "}
              <i class="fab fa-github"></i>
            </a>
            <a
              href="https://www.linkedin.com/in/md-riyad-talukder-913978210/"
              className="btn text-white ico ms-2 "
              target="_blank"
            >
              {" "}
              <i class="fab fa-linkedin-in"></i>
            </a>
            <a
              href="mailto:mdriyadtalukder.cse@gmail.com"
              className="btn text-white ico ms-2"
            >
              <i class="fas fa-envelope"></i>
            </a>
          </div>
          <h5>
            Designed and Developed by{" "}
            <span className="myname">Md Riyad Talukder</span>
          </h5>
          <h5>Copyright © {year}, All Rights Reserved</h5>
        </div>
      </div>
    </div>
  );
};

export default Footer;
